import { MatterLedgerLayout } from './layouts';
import { MatterLedgerHistoryView } from './components/MatterLedgerHistoryView';

export function MatterLedgerHistoryPage() {
  return (
    <MatterLedgerLayout>
      <MatterLedgerHistoryView />
    </MatterLedgerLayout>
  );
}

